import React from 'react';

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'default';

export interface ChipProps {
  label: React.ReactNode;
  variant?: Variant;
  className?: string;
}

const variantClass: Record<Variant, string> = {
  success: 'chip chip-success',
  warning: 'chip chip-warning',
  danger: 'chip chip-danger',
  info: 'chip chip-info',
  default: 'chip bg-gray-100 text-gray-700',
};

const Chip: React.FC<ChipProps> = ({ label, variant = 'default', className }) => {
  return <span className={`${variantClass[variant]} ${className ?? ''}`.trim()}>{label}</span>;
};

export default Chip;

